// extracted by mini-css-extract-plugin
export default {"container":"People_container__+YYwX","text":"People_text__Zkrow","buttons_block":"People_buttons_block__G3Uti","button":"People_button__cuPnA","choose":"People_choose__eshjY"};